import * as C from '../constants';
import { values } from 'lodash';
import {
  MARKET_PROVIDERS_FETCHING,
  MARKET_PROVIDERS_FETCHED,
} from '../actions/DataGatePageActionCreators';

const makeSSDefaultChannel = (translations: any) => ({
  alias: null,
  alternate_name: '',
  company: {
    name: '',
  },
  company_id: 1,
  cover_photo_url: null,
  created_at: '',
  data_items: values(translations.ssDefaultChannel.products).map(
    (name: string) => ({
      preference_product: { name },
    })
  ),
  description: translations.ssDefaultChannel.description,
  display_logo: 'https://webstage.sourcesage.co/img/optimized/dp.jpg',
  id: C.LEGACY_DATA_PAGE.DUMMY_SS_DEFAULT_CHANNEL_ID,
  is_public: true,
  name: translations.ssDefaultChannel.channelName,
});

export const getDataGatePageMyChannels = (state: DataGatePageState) => (
  translations: any
) => state.data.my_channels;

export const getDataGatePagePublicChannels = (state: DataGatePageState) => (
  translations: any
) => {
  const items = [...state.data.public_channels.items];
  if (
    items[0] &&
    items[0].id !== C.LEGACY_DATA_PAGE.DUMMY_SS_DEFAULT_CHANNEL_ID
  ) {
    items.unshift(makeSSDefaultChannel(translations));
  }
  return { ...state.data.public_channels, items };
};

export const getDataGatePagePrivateChannels = (state: DataGatePageState) => (
  translations: any
) => state.data.private_channels;

const defaultState = {
  isFetching: false,
  data: {
    my_channels: {
      items: [],
    },
    public_channels: {
      items: [],
    },
    private_channels: {
      items: [],
    },
  },
};

export function dataGatePage(
  state: DataGatePageState = defaultState,
  action: DataGatePageAction
) {
  switch (action.type) {
    case MARKET_PROVIDERS_FETCHING: {
      return { ...state, isFetching: true };
    }
    case MARKET_PROVIDERS_FETCHED: {
      const {
        my_channels,
        public_channels,
        private_channels,
      } = action.payload.data;

      return {
        ...state,
        data: {
          my_channels: {
            items: my_channels.items,
          },
          public_channels: {
            items: public_channels.items,
          },
          private_channels: {
            items: private_channels.items,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/dataGatePage.ts